import Vue from 'vue'
import App from './App'
import router from './router' // 路由
import store from './store' // vuex
import "./utils/rem" // rem
import "./utils/reset.css" // 公共css样式
import "./utils/index.css" // 项目公共css样式
import utils from '../src/utils/utils'//公共方法
Vue.prototype.$fn = utils
import request from './utils/requestAxios'//公共axios
Vue.prototype.$axios = request

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 引入手机端调试
// import Vconsole from 'vconsole';
// const vConsole = new Vconsole();
// Vue.use(vConsole)

// vant框架引入
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// 统计代码
var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
  // console.log(window.location.host)   //判断域名
  if (window.location.host == 'jiufu.taolai.com') {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?4103d1139e407ea0d7a400e1ea77885b";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  } else if (window.location.host == 'jiufu.taolai.com') {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?ab94ca3041015b111eb28744e7a64920";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  }
})();

// 图片域名
Vue.prototype.baseURL = process.env.OSS_DOMAIN

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js